import React, { useEffect } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { NeuroMessage } from '@ignitesales/neuro-application/src/neuro-guide';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components/MessageContext';
import {
  triggerIgniteAction,
  useDispatch
} from '@ignitesales/neuro-application/src/neuro-guide/state';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui/index';

const SendToInsightComplete = ({ className, closeBtn, isOpen, onClose }) => {
  const messageContext = useNeuroMessages();
  const classes = classnames(className, 'sendToInsightComplete');

  return (
    <Modal
      show={isOpen}
      className={classes}
      title={messageContext.getMessage('sendToInsightComplete.modal.title')}
      onClose={onClose}
      closeBtn={closeBtn}
      nodeId="root"
    >
      <div className="sendToInsightComplete">
        <NeuroMessage id='sendToInsightComplete.message' tagName='h4' />
      </div>
    </Modal>
  );
};
SendToInsightComplete.propTypes = {
  className: PropTypes.string,
  closeBtn: PropTypes.any,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SendToInsightComplete;
